<template>

    <div class="columns is-gapless" id="discussion" v-if="quoteRequest.company">
        <a class="btn-close-messages" @click="closeMessages" style="padding: 10px"><i class="fa fa-times"></i></a>
        <div class="container">
            <section id="toggle_messages">
                  <div class="columns">
                    <div class="column">
                        <div class="">
                            <div class="">
                                <textarea class="textarea message-field" v-model="messageString"
                                          :placeholder="`Send a new message to ${quoteRequest.company.email}`"
                                          rows="2"></textarea>
                            </div>
                            <div class="">
                                <button class="button is-dark level-item" @click="sendMessage()"
                                        v-bind:disabled="sending === true || messageString === ''">Send Message
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="columns"
                     v-for="(message, index) in messages.slice().reverse()"
                     v-bind:key="index"
                     style="margin-bottom: 0;">
                    <div class="column is-four-fifths" v-if="message.type === 'Info'"
                         v-bind:class="{'is-offset-one-fifth': message.senderId === ID_Recipient}">
                        <article class="message-box message"
                                 v-bind:class="(message.senderId !== ID_Recipient) ? 'is-info' : 'is-success'">
                            <span class="message-time">{{(message.senderId === ID_Recipient) ? `Sent ${message.time}` : `Received ${message.time}`}}</span>
                            <div style="padding: 0;" v-text="message.text"></div>
                        </article>
                    </div>
                </div>
            </section>
        </div>
    </div>

</template>

<script>

import axios from 'axios'

export default {
  name: 'aside-discussion',
  props: ['quoteRequest', 'messages', 'showMessages', 'step', 'stepReached'],
  mounted () {
  },
  data () {
    return {
      sending: false,
      messageString: ''
    }
  },
  methods: {
    sendMessage () {
      const AuthStr = `Bearer ${this.id}`
      this.sending = true
      axios.post(`${window.APP_CONFIG.apiServiceUrl}quoterequest/portal/message`,
        {text: this.messageString},
        {
          headers: {Authorization: AuthStr}
        })
        .then(response => {
          if (response.status === 200) {
            this.messageString = ''
            this.sending = false
          }
        })
        .catch((error) => {
          console.log('send error', error, this)
        })
    },
    closeMessages () {
      this.$emit('closeNotification')
    }
  },
  computed: {
    id () {
      return this.$store.state.token
    },
    ID_Recipient () {
      return this.$store.state.data.recipient.iD_QuoteRequestRecipient
    }
  }
}
</script>
